<template>
  <h2>
    <span class="headline-box">
      <slot></slot>
    </span>
  </h2>
</template>

<script>
export default {
  name: 'Headline'
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/variables';
h2 {
  font-size: 28px;
  display: flex;
  justify-content: center;
}

.headline-box {
  display: block;
  width: 300px;
  text-align: center;
  border-bottom: 1px solid $text-white;
  padding: 4px;
  margin: 4px;
  &:before,
  &:after {
    content: '-';
    margin: 4px;
  }
}

@media screen and (max-width: 980px) {
  .headline-box {
    box-sizing: border-box;
    width: 100%;
    margin: 4px 0;
    padding: 4px 0;
  }
}
</style>
